import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { DependencyFilterKeys } from '../../../../../../shared/dependenciesV2';
import { DependencySource } from '../../../../../../shared/vendoredDependencies';
import * as DependenciesV2Store from '../../../../../redux/dependenciesV2';
import { selectOptionFactory } from '../../../../../utils';
import FilterCardCheckboxes from '../../../../generic/Filter/FilterCardCheckboxes';
import useFetchDependenciesAction from '../../hooks/useFetchDependencyAction';
import type { SelectOption } from '../../../../../types';

// Filter labels by key value
const FILTER_LABELS: Record<DependencySource, string> = {
  [DependencySource.Managed]: 'Managed',
  [DependencySource.Vendored]: 'Vendored',
};

// Built filter options for checkbox filter
const FILTER_OPTIONS: SelectOption[] = Object.entries(FILTER_LABELS).map(([value, label]) =>
  selectOptionFactory(value, label),
);

/**
 * Dependency source filter which allows the user to filter dependencies by source.
 */
const DependencySourceFilter: VoidFunctionComponent = () => {
  const filters = useSelector(DependenciesV2Store.selectors.getFilters);
  const setFilter = useFetchDependenciesAction(DependenciesV2Store.actions.setFilters);

  const selectedOptions = (filters.sources ?? []).map((option: DependencySource) => ({
    label: FILTER_LABELS[option],
    value: option,
  }));

  const onChange = (selected: SelectOption[]) => setFilter({
    ...filters,
    [DependencyFilterKeys.Sources]: selected.map((option) => option.value),
  });

  return (
    <FilterCardCheckboxes
      label="Source"
      options={FILTER_OPTIONS}
      values={selectedOptions}
      onChange={onChange}
    />
  );
};

export default DependencySourceFilter;
